// @ts-ignore
import { useSelector } from 'react-redux';
import { getCurrentPath } from '../selectors/routing';

export const getPath = () => useSelector(getCurrentPath);